import { render, staticRenderFns } from "./ZaloHubPancake.vue?vue&type=template&id=dc774ac6"
import script from "./ZaloHubPancake.vue?vue&type=script&lang=js"
export * from "./ZaloHubPancake.vue?vue&type=script&lang=js"
import style0 from "./ZaloHubPancake.vue?vue&type=style&index=0&id=dc774ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports